
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/map/[path]",
      function () {
        return require("private-next-pages/map/[path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/map/[path]"])
      });
    }
  